module.exports = __webpack_public_path__ + "static/media/1 43 aldri.f374f178.mp3";